import React, { useEffect, useState } from "react";
import Footer2 from "../Components/Footer2";
import Navbar2 from "../Components/Navbar2";
import img from "../Assets/hiring.png";
// import img2 from "../Assets/Classroom-rafiki 4.png";
import { useParams } from "react-router-dom";
import { getSingleService } from "../Common/apis";
import Loader from "../Loader/Loader";
import Aos from "aos";

function CorporateHiring() {
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchService = async () => {
      try {
        const res = await getSingleService(id);
        setService(res.data);
      } catch (err) {
        console.error("Error fetching service:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchService();
  }, [id]);

  return (
    <div className="new-home">
      <Navbar2 />
      {loading ? (
        <Loader />
      ) : !service ? (
        <p>Service not found!</p>
      ) : (
        <>
          <div className="grid md:grid-cols-2 grid-cols-1 md:gap-[182px] gap-[10px] md:px-[80px] px-[20px] md:pt-[74px] pt-[30px]">
            <div>
              <img src={img} alt="vector" className="md:mb-[60px] mb-[40px]" />
              <div className="h-box">
                <h6 dangerouslySetInnerHTML={{ __html: service.shortdescription }} className="font-sans font-[500] md:text-[31px] text-[20px] md:leading-[42px] leading-[32px] text-[#6953A3] md:pt-[74px] pt-[50px] md:max-w-[365px] max-w-[264px] w-full mx-auto text-center md:pb-[30px] pb-[20px]" />
              <p dangerouslySetInnerHTML={{ __html: service.description }} className="font-sans font-[400] md:text-[16px] text-[11px] md:leading-[26px] leading-[22px] text-center text-[#6953A3] md:max-w-[316px] max-w-[223px] w-full mx-auto" />
              </div>
            </div>
            <div>
              <img src="/assets/home/vector7.svg" alt="" />
              <div className="shape-1-div">
                {service &&
                  service.tags &&
                  service.tags.length > 0 &&
                  service.tags.map((tag, index) => (
                    <div key={index} className="shape-icon-1">
                      {index % 2 === 0 ? (
                        <>
                          <div className="shape-icon"></div>
                          <div className="shape-text">
                            <p>{tag}</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="shape-text shape-text2">
                            <p>{tag}</p>
                          </div>
                          <div className="shape-icon"></div>
                        </>
                      )}
                    </div>
                  ))}
                {/* <div className="shape-icon-1">
                  <div className="shape-icon"></div>
                  <div className="shape-text">
                    <p>Large Course Portfolio</p>
                  </div>
                </div>
                <div className="shape-icon-1">
                  <div className="shape-text shape-text2">
                    <p>Large Course Portfolio</p>
                  </div>
                  <div className="shape-icon"></div>
                </div>
                <div className="shape-icon-1">
                  <div className="shape-icon"></div>
                  <div className="shape-text">
                    <p>Large Course Portfolio</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          {/* <div className="hiring">
            <div className="hiring-left">
              <img src={img} />
              <br />
              <div className="hiring-box">
            
                <div
                  className="short-desc"
                  dangerouslySetInnerHTML={{ __html: service.shortdescription }}
                />
                <br />
                <div
                  className="rich-content"
                  dangerouslySetInnerHTML={{ __html: service.description }}
                />
              </div>
            </div>
            <div className="hiring-right">
              <img
                src={service.image}
                alt={service.title}
                width="500px"
                height="500px"
                style={{ objectFit: "cover" }}
              />
              <br />
              <br />
              
            </div>
          </div> */}
        </>
      )}
      <Footer2 />
    </div>
  );
}

export default CorporateHiring;
